export function MarkedAsBookedViewedByHost() {
  return "The organiser has marked this enquiry as booked. Please confirm the booking details";
}

export function MarkedAsBookedViewedByOrganiser() {
  return "Enquiry marked as booked";
}
